var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.53.426a1.507 1.507 0 0 0-2.132 0L7.977 5.853 2.556.426a1.507 1.507 0 0 0-2.132 0 1.511 1.511 0 0 0 0 2.134l5.422 5.426-5.422 5.427a1.507 1.507 0 1 0 2.132 2.133l5.421-5.426 5.421 5.426a1.507 1.507 0 0 0 2.132 0 1.51 1.51 0 0 0 0-2.133l-5.421-5.427L15.53 2.56a1.511 1.511 0 0 0 0-2.134Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossBold);
export default ForwardRef;